import { IEventRecord, IEventTypes } from "@home-health-notify/domain";
import { Divider } from "@mui/material";
import { formatRescheduleDateTime, UserDirectoryContext } from "hhn-commons";
import { useContext } from "react";
import {
  TimelineItemHeader,
  TimelineItemWrapper,
  UpdatedAt,
} from "./CareTimeline.style";
import CareTimelineFormItem from "./CareTimelineFormItem";
import CareTimelineUserUpdateItem from "./CareTimelineUserUpdateItem";

const CareTimelineItem = ({ timelineItem }: { timelineItem: IEventRecord }) => {
  const { userDirectory } = useContext(UserDirectoryContext);
  const userData = userDirectory.getUserInfo(timelineItem.updatedBy);
  return (
    <TimelineItemWrapper>
      <TimelineItemHeader>
        <Divider />
        <UpdatedAt>
          {formatRescheduleDateTime(timelineItem.updatedAt)}
        </UpdatedAt>
        <Divider />
      </TimelineItemHeader>
      {timelineItem.type === IEventTypes.FORM && (
        <CareTimelineFormItem timelineItem={timelineItem} userData={userData} />
      )}
      {timelineItem.type === IEventTypes.USER_UPDATE && (
        <CareTimelineUserUpdateItem
          timelineItem={timelineItem}
          userData={userData}
        />
      )}
      {timelineItem.type !== IEventTypes.USER_UPDATE &&
        timelineItem.type !== IEventTypes.FORM &&
        "Some Update"}
    </TimelineItemWrapper>
  );
};

export default CareTimelineItem;
